module.exports = __webpack_public_path__ + "static/img/tx5.a2a59bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/tx5.jpg
// module id = sl5Y
// module chunks = 4